import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function RealitySection() {
  return <section className="py-24 px-4 relative overflow-hidden bg-slate-900 border-y border-slate-800" data-id="element-259">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-900/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-260"></div>

      <div className="max-w-4xl mx-auto" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-262">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-263">
            Imagina Esto...
          </h2>

          <div className="space-y-6 text-xl text-slate-300 leading-relaxed mb-12" data-id="element-264">
            <p data-id="element-265">Son las 11 PM. Estás con tu pareja. Todo fluye.</p>
            <p data-id="element-266">No hay dudas. No hay ansiedad. No hay "¿funcionará?"</p>
            <p className="text-blue-400 font-semibold" data-id="element-267">
              Solo tú, en control total de tu cuerpo. Como solía ser. Como
              debería ser siempre.
            </p>
          </div>

          <div className="bg-slate-950 p-8 rounded-3xl border border-slate-800 text-left max-w-3xl mx-auto" data-id="element-268">
            <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-269">
              Esto No es un Sueño. Es Fisiología.
            </h3>
            <p className="text-slate-400 text-center mb-8" data-id="element-270">
              En menos de 7 días, la mayoría de los hombres experimenta:
            </p>

            <ul className="space-y-4 mb-8" data-id="element-271">
              {['Firmeza consistente sin depender de químicos', 'Confianza renovada que se nota en tu postura, tu voz, tu presencia', 'Control total sobre tu respuesta física', "Discreción absoluta - nadie necesita saber tu 'secreto'"].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-272">
                  <CheckCircle2 className="w-6 h-6 text-emerald-500 shrink-0" data-id="element-273" />
                  <span className="text-slate-300" data-id="element-274">{text}</span>
                </li>)}
            </ul>

            <div className="text-center p-4 bg-blue-900/20 rounded-xl border border-blue-500/30" data-id="element-275">
              <p className="text-slate-300" data-id="element-276">
                No es magia. No es suerte. No es juventud recuperada.
              </p>
              <p className="text-white font-bold mt-2" data-id="element-277">
                Es tu cuerpo funcionando como fue diseñado para funcionar.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}